import { Box, Flex, Text } from '@chakra-ui/react';
import { useState } from 'react';

type Option = {
  value: string;
  label: string;
};

type MultiSwitchProps = {
  options: Option[];
  defaultValue: string;
  onChange: (val: string) => void;
};

export const MultiSwitch = ({ options, defaultValue, onChange }: MultiSwitchProps) => {
  const [value, setValue] = useState(defaultValue);

  const handleChange = (val: string) => {
    setValue(val);
    onChange(val);
  };

  return (
    <Flex
      borderRadius="full"
      overflow="hidden"
      border="1px solid"
      borderColor="gray.500"
      bg="transparent"
      userSelect="none"
    >
      {options.map((opt, idx) => {
        const isSelected = value === opt.value;
        return (
          <Box
            key={opt.value}
            flex="1"
            position="relative"
            bg={isSelected ? 'primary.600' : 'transparent'}
            color={isSelected ? 'white' : 'white.400'}
            display="flex"
            alignItems="center"
            justifyContent="center"
            cursor={!isSelected ? 'pointer' : 'default'}
            transition="background 0.15s"
            borderRight={idx !== options.length - 1 ? '1px solid' : undefined}
            borderColor="primary.600"
            onClick={() => !isSelected && handleChange(opt.value)}
            px="2"
            py="0.5"
          >
            <Text position="relative" zIndex={2} fontWeight="bold" fontSize="xs" whiteSpace="nowrap">
              {opt.label}
            </Text>
          </Box>
        );
      })}
    </Flex>
  );
};
